import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchTrainersByIctId } from "../../../store/ictTrainersByIctIdSlice";
import { fetchICTData } from "../../../store/uiSlice"; // assuming uiSlice has ictData
import { fetchEmployees } from "../../../store/empDataSlice";

const IctTrainersList = () => {
  const dispatch = useDispatch();

  const { data: trainers = [], loading, error } = useSelector((state) => state.ictTrainersByIctId);
  const { ictData = [] } = useSelector((state) => state.ui);
  const { employees = [] } = useSelector((state) => state.empData);

  const [searchName, setSearchName] = useState("");
  const [filteredIct, setFilteredIct] = useState([]);

  useEffect(() => {
    dispatch(fetchICTData());
    dispatch(fetchEmployees());
  }, [dispatch]);

  useEffect(() => {
    const filtered = ictData.filter((ict) =>
      ict.ictName.toLowerCase().includes(searchName.toLowerCase())
    );
    setFilteredIct(filtered);
  }, [searchName, ictData]);

  const handleSelect = (ictId) => {
    dispatch(fetchTrainersByIctId(ictId));
    setSearchName("");
    setFilteredIct([]);
    console.log("Fetching trainers for ictId:", ictId);
  };

  // Get emp name by empId
  const getEmpName = (empId) => {
    const emp = employees.find((e) => e.id === empId);
    return emp ? `${emp.empFName} ${emp.empLName}` : empId;
  };

  return (
  <div className="container">
    <div className="header-container">
      <h2>Search ICT</h2>
      <div className="feedback-filters-ict">
        <input
          type="text"
          placeholder="Search ICT Name"
          value={searchName}
          onChange={(e) => setSearchName(e.target.value)}
          className="filter-input feedback-filters-ict"
        />
        {searchName && filteredIct.length > 0 && (
          <ul className="ict-suggestions-list">
            {filteredIct.map((ict) => (
              <li
                key={ict.id}
                onClick={() => handleSelect(ict.id)}
              >
                {ict.ictName}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>

      {loading && <p>Loading trainers...</p>}
      {error && <p className="ict-error">Error: {error}</p>}

      {!loading && !error && trainers.length > 0 && (
        <table border="1" cellPadding="8" cellSpacing="0" className="table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Trainer Name</th>
              <th>Training Mode</th>
              <th>Cost Online</th>
              <th>Cost Classroom</th>
              <th>Is FL</th>
              <th>Status</th>
              <th>Created</th>
              <th>Updated</th>
            </tr>
          </thead>
          <tbody>
            {trainers.map((trainer) => (
              <tr key={trainer.id}>
                <td>{trainer.id}</td>
                <td>{getEmpName(trainer.empId)}</td>
                <td>{trainer.trainerTrainingMode}</td>
                <td>{trainer.trainerCostOnline}</td>
                <td>{trainer.trainerCostClassRoom}</td>
                <td>{trainer.isFL}</td>
                <td>{trainer.status}</td>
                <td>{new Date(trainer.created).toLocaleString()}</td>
                <td>{new Date(trainer.updated).toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default IctTrainersList;
